function FormError({ formik, fieldName }: { formik: any; fieldName: string }) {
  if (!formik.touched[fieldName] || !formik.errors[fieldName]) {
    return null;
  }
  return (
    <div className="fv-plugins-message-container">
      <div className="fv-help-block text-danger " style={{ fontSize: "12px" }}>
        <span role="alert">{formik.errors[fieldName]}</span>
      </div>
    </div>
  );
}

export default FormError;
